module.exports = __webpack_public_path__ + "media/images/area/popular/kanazawa-1e9acd2ad474813220f96239205455f6.jpg";